import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry } from './config/sentry';
import './index.css';
import App from './App.tsx';
import { watchForNewVersion } from './lib/serviceWorkerUpdate';

initSentry();
watchForNewVersion();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
